// extracted by mini-css-extract-plugin
export default {"container":"Lk-z","disabled":"Mk-z","subtotal":"Nk-z","legal":"Ok-z"};